import { render } from "./WorldNpc2.vue?vue&type=template&id=606d7fd9&scoped=true"
import script from "./WorldNpc2.vue?vue&type=script&lang=js"
export * from "./WorldNpc2.vue?vue&type=script&lang=js"

import "./WorldNpc2.vue?vue&type=style&index=0&id=606d7fd9&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606d7fd9"]])

export default __exports__